const getters = {
  getTabData: (state) => (tabName) => {
    return state.tabData[tabName] || null;
  },
};

export default getters;
